/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Avatar, Divider, Modal, Select, Menu, Dropdown } from "antd";
import { withRouter } from "react-router";
import { useQuery } from "react-query";
import { CheckOutlined } from "@ant-design/icons";
import { get } from "lodash";
import cx from "classnames";
import { getFgaProject, getUser } from "metabase/selectors/user";
import { QUERY_OPTIONS } from "metabase/ab/utils/utils";
import { getEcosystemGameList, GetFgaProject } from "metabase/new-service";
import { loadCurrentFgaProject } from "metabase/redux/user";
import "../css/index.css";
import * as MetabaseAnalytics from "metabase/lib/analytics";
import { setGames } from "metabase/redux/control";
import Icon from "metabase/components/Icon";
import { getOssUrl } from "metabase/lib/image";
import { getGrowthProjectPath, getLatestGAProject, getProjectAlias, saveLatestGAProject, saveLatestGAProjectId } from "../utils/utils";
import { DownOutlined } from '@ant-design/icons';

const GaProjectSearch = props => {
  const {
    router,
    location,
    user,
    menu,
    projectPath,
    setCreateFgaProjectModalShowAction,
    logout,
    className,
    enableFirstGa,
    dispatch,
    collapsed,
  } = props;
  const [open, setOpen] = useState(false);
  const [userProject, setUserProject] = useState([]);
  const [currentProject, setCurrentProject] = useState(projectPath);
  const projectId = get(user?.projectIds, "0")
  const { isLoading, data } = useQuery(
    ["GetFgaProject", user?.id],
    async () => {
      const isTestTeamFeature415 = user?.isTestTeamFeature415
      const ecosystemId = user?.isTestTeamFeature416 ? 416 : 415;
      const data = await getEcosystemGameList({ecosystemId: ecosystemId});
      if (user?.id === 186) {
        return data
      }
      /*
      if (isTestTeamFeature415) {
        return data?.filter(el => user?.roles?.map(i => i.projectId)?.includes(el.projectId))
        // return data?.filter(el => el.projectName === "ApeCoin")
      }*/
      /*if (betaUser2.includes(user?.id)) {
        return data?.filter(el => betaUser2Project.includes(el.projectName))
      }*/
      /*if (demoUser.includes(user?.id)) {
        return data?.filter(el => demoUserProject.includes(el.projectName))
      }*/
      return data?.filter(el => el.projectName !== "Project A")
    },
    { ...QUERY_OPTIONS, enabled: !!user },
  );

  const loadProjectDetail = project_id => {
    props.dispatch(loadCurrentFgaProject(project_id));
  };
  useEffect(() => {
    if (!isLoading && data) {
      if (data?.length > 0) {
        const projects = [];
        data?.map(p => {
          projects.push({
            ...p,
            value: p.projectName,
            label:
              <div className="flex align-center">
                <img className="mr1" style={{width: 16, height: 16}} src={p.icon ? p.icon : getOssUrl(`/ab/Project A.png?image_process=resize,w_16/crop,h_16/format,jpg`)} alt={p.projectName}/>
                {p.projectName}
              </div>,
            key: p.projectName,
            id: p.projectId,
            projectName: p.projectName,
            alias: p.alias
          });
        });
        const index = projects.findIndex(i => i.alias === currentProject);
        let userProjectIndex = projects.findIndex(i => i.projectId === projectId);
        if (userProjectIndex === -1) {
          userProjectIndex = 0
        }

        const projectIndex = index === -1 ? userProjectIndex || 0 : index;

        if (enableFirstGa) {
          MetabaseAnalytics.trackStructEvent2("Standard Dashboard Events", "SelectProject", projects[projectIndex].projectName, 1,
            {
              project_name: projects[projectIndex].projectName,
            })
        }
        setCurrentProject(projects[projectIndex].alias);
        saveLatestGAProject(projects[projectIndex].alias);
        saveLatestGAProjectId(projects[projectIndex].id);
        loadProjectDetail(projects[projectIndex].id);
        setUserProject(projects);
        dispatch(setGames(projects));
        if (
          (
            index === -1 ||
            location.pathname === "/ab" ||
            location.pathname.startsWith("/ab/project")
          ) &&
          !location.pathname.startsWith("/ab/public")
        ) {
          router?.push({
            pathname: getGrowthProjectPath(projects[projectIndex].alias, menu),
            query: router?.location?.query,
          });
        }
      } else {
        setUserProject([]);
        router?.push("/ab/games-manage");
        // if (user) {
        //   checkIsNeedContactUs(
        //     modal,
        //     null,
        //     () => {
        //       setCreateFgaProjectModalShowAction({ show: true });
        //     },
        //     () => {},
        //     false,
        //   );
        //   // setCreateFgaProjectModalShowAction?.({
        //   //   show: true,
        //   //   force: true,
        //   // });
        // }
      }
    }
    // getAllProtocol();
  }, [data, isLoading]);


  useEffect(() => {
    if (projectPath && projectPath !== "undefined") {
      setCurrentProject(projectPath);
      saveLatestGAProject(projectPath);
    } else {
      const temp_project =
        getLatestGAProject() ??
        (userProject?.length > 0 ? userProject[0].projectName : null);
      if (temp_project) {
        saveLatestGAProject(temp_project);
        setCurrentProject(temp_project);
        if (
          location.pathname.startsWith("/ab/project") ||
          location.pathname === "/ab"
        ) {
          router?.push({
            pathname: getGrowthProjectPath(temp_project),
          });
        }
      }
    }
  }, [projectPath]);

  const handleProjectChange = (value) => {
    const option = userProject.find(i => i.projectName === value.key);
    saveLatestGAProject(option.projectName);
    setCurrentProject(option.alias);
    if (option.id) {
      // saveLatestGAProjectId(option.id);
      loadProjectDetail(option.id);
    }
    if (
      (location.pathname.startsWith("/ab/project") ||
        location.pathname === "/ab") &&
      option.projectName
    ) {
      // window.location.href = getGrowthProjectPath(option.value);
      router?.push({
        pathname: getGrowthProjectPath(option.alias),
      });
    }
  };
  const getValue = () => {
    const option = userProject.find(i => i.alias === currentProject);
    if (!option) {
      return null
    }
    return {
      key: currentProject,
      label: (
        <div className="ab-project-select__select-wrapper">
          <Avatar src={option.icon}/>
          {showText &&
            <span>
              {getProjectAlias(option)}
            </span>
          }
        </div>
      )
    }
  }
  const calProjectId = (str) => {
    const match = str.match(/\d+/);
    return match ? parseInt(match[0], 10) : null
  }
  const getProjectRole = (projectName) => {
    const project = data?.find(i => i.projectName === projectName);
    const role = user?.role
    if (user?.isTestTeamFeature415 || user?.isTestTeamFeature416) {
      const roles = user?.roles
      const projectRoles = roles?.filter(r => calProjectId(r.roleName) === project?.projectId)
      if (projectRoles.find(r => r.role === "Manager")) {
        return "Project Admin"
      } else if (projectRoles.find(r => r.role === "Data User")) {
        return "Normal Access"
      }
      return "View Only"
    }
    if (role === "ecosystem") {
      return "Project Admin"
    } else if (role === "general") {
      return "View Only"
    } else {
      return "View Only"
    }
  }

  const getProjectRoleColor = (projectName) => {
    const role = getProjectRole(projectName);
    if (role === "Project Admin") {
      return "#64F09C";
    } else if (role === "View Only") {
      return "#FFBA68";
    } else {
      return "#C1C7D0";
    }
  }
  const showText = true;
  // const showText = !collapsed;
  const handleDropdownVisibleChange = (open) => {
    if (!open) {
      setOpen(false);
    }
  };

  const handleMouseEnter = () => {
    setOpen(true);
  };

  const handleMouseLeave = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (collapsed) {
      setOpen(false)
    }
  }, [collapsed]);

  const ProjectDropdown = () => {
    return (
      <Dropdown
        className="ab-project-select__dropdown-menu"
        trigger={['click']}
        open={open}
        arrow={false}
        icon={null}
        buttonsRender={null}
        dropdownRender={() => (
          <div
            className="ab-project-dropdown"
            onMouseLeave={handleMouseLeave}
            style={{
              maxHeight: 360,
              width: 236,
              border: '1px solid #353945',
              overflowY: 'auto',
              background: '#242427',
              borderRadius: 4,
              marginLeft: collapsed ? 20 : 0,
              marginTop: collapsed ? -24 : 0,
              scrollbarColor: '#353945 #242427',
              scrollbarWidth: 'thin',
              padding: "8px 6px 8px 8px",
            }}
          >
            {userProject.map(option => (
              // eslint-disable-next-line react/jsx-key
              <div
                className="flex items-center justify-between"
                style={{
                  gap: 8,
                  cursor: 'pointer',
                  padding: '2px 10px',
                  margin: '2px 0',
                  position: 'relative',
                  transition: 'background-color 0.3s',
                  ':hover': {
                    backgroundColor: '#ffffff10'
                  },
                  borderRadius: 4,
                  backgroundColor: option.alias === currentProject ? '#ffffff20' : 'transparent'
                }}
                onClick={() => handleProjectChange({key: option.projectName})}
                onMouseEnter={(e) => {
                  if(option.projectName !== currentProject) {
                    e.currentTarget.style.backgroundColor = '#353945'
                  }
                }}
                onMouseLeave={(e) => {
                  if(option.projectName !== currentProject) {
                    e.currentTarget.style.backgroundColor = 'transparent'
                  }
                }}
              >
                <div className="flex items-center">
                  <Avatar src={option.icon} size={20} >
                    {option.alias?.charAt(0)?.toUpperCase()}
                  </Avatar>
                  <div className="flex flex-column ml1">
                    <span style={{maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{getProjectAlias(option)}</span>
                    <span style={{color: getProjectRoleColor(option.projectName), fontSize: 12}}>
                      {getProjectRole(option.projectName)}
                    </span>
                  </div>
                </div>
                {option.alias === currentProject && <CheckOutlined style={{color: '#74FFCD', position: 'absolute', right: 10}}/>}
              </div>
            ))}
          </div>
        )}
        placement={collapsed ? "rightBottom" : "bottom"}
        getPopupContainer={() => document.body}
      >
        <div
          className="ab-project-trigger"
          style={{borderRadius: !collapsed ? 20 : 4, width: !collapsed ? "96%" : "86%"}}
          onClick={() => setOpen(true)}
        >
          <div className="flex items-center">
            <Avatar src={userProject?.find(p => p.alias === currentProject)?.icon} size={30} >
              {userProject?.find(p => p.alias === currentProject)?.alias?.charAt(0)?.toUpperCase()}
            </Avatar>
            {!collapsed && (
              <div className="flex flex-column ml1">
                <span style={{maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{getProjectAlias(userProject?.find(p => p.alias === currentProject))}</span>
              </div>
            )}
          </div>
          {!collapsed && <DownOutlined size={20} color={"white"}/>}
        </div>
      </Dropdown>
    );
  };

  return (
    <div className={cx(`flex flex-column items-center ga-project-search ${collapsed ? "ab-project-select-collapsed": ""}`, className)}
         style={{ width: collapsed ? 60: 234, margin: collapsed ? "0 0 0 6px" : "0 0 0 16px" }}>
      {!isLoading && (
        <>
          {userProject?.length > 0 && (
            <ProjectDropdown />
          )}
        </>
      )

        //  : (
        //   <Skeleton.Button
        //     active={true}
        //     className="flex flex-column items-center"
        //     style={{ width: 300, height: 30, marginTop: 15, padding: 0 }}
        //     paragraph={false}
        //   />
        // )
      }
    </div>
  );
};

const mapStateToProps = (state, props) => {
  return {
    user: getUser(state),
    projectObject: getFgaProject(state),
    projectPath: props.params.project,
    menu: props.params.menu,
  };
};

export default withRouter(connect(mapStateToProps)(GaProjectSearch));
